// Formata progressivamente: aplica o separador assim que o grupo fecha, para
// servir tambem como mascara de digitacao. Valor completo sai igual ao de antes.
export function CnpjMask(cnpj: string): string {
  if (!cnpj) return cnpj;

  return cnpj
    .replace(/\D/g, '')
    .slice(0, 14)
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5');
}
